interface OfflineBannerProps {
  visible: boolean;
}

export default function OfflineBanner({ visible }: OfflineBannerProps) {
  if (!visible) return null;

  return (
    <div className="bg-[#FFF3E0] border-b border-[#F57C00]/30 px-4 py-2.5 text-center">
      <div className="flex items-center justify-center gap-2">
        <i className="ri-wifi-off-line text-[#F57C00] text-sm" />
        <span className="text-xs font-medium text-[#F57C00] font-heading">
          Modo offline ativo — os dados serão salvos localmente e sincronizados quando houver conexão.
        </span>
      </div>
    </div>
  );
}